import { t } from 'i18next';
import { DateTime } from 'luxon';
import { CSSProperties, useEffect, useState } from 'react';
import { Stack } from 'rsuite';
import { useGetSystemDataQuery } from '../services';
import { FeedbackSystem } from './FeedbackSystem';

interface IProps {
  server: string;
  pdf?: any;
  style?: CSSProperties;
}
export const Footer = ({ server, pdf, style }: IProps) => {
  const currentYear = DateTime.fromJSDate(new Date()).year;
  const [version, setVersion] = useState<string>('');
  const [privacyUrl, setPrivacyUrl] = useState<string>('');
  const [releaseNoteUrl, setReleaseNoteUrl] = useState<string>('');
  const [termServiceUrl, setTermServiceUrl] = useState<string>(`${pdf}`);
  const { data: systemData } = useGetSystemDataQuery({
    server: server
  });

  useEffect(() => {
    if (systemData?.portal_version) {
      setVersion(systemData.portal_version);
      setPrivacyUrl(systemData.privacy_url);
      setReleaseNoteUrl(systemData.release_note_url);
      if (systemData?.terms_of_service) {
        setTermServiceUrl(systemData?.terms_of_service);
      }
    }
  }, [systemData]);
  return (
    <Stack
      className="frame-footer"
      justifyContent="space-between"
      style={style}
    >
      <Stack justifyContent="flex-start" spacing={40} alignItems="center">
        <a href={termServiceUrl} target="_blank">
          {t('common.footer.termsOfService')}
        </a>
        <a href={privacyUrl} target="_blank">
          {t('common.footer.privacyPolicy')}
        </a>
        <a href={releaseNoteUrl} target="_blank">
          {t('common.footer.releaseNotes')}
        </a>
        {/* <FeedbackSystem server={server} /> */}
      </Stack>
      <Stack justifyContent="flex-end" spacing={20}>
        <span>{version}</span>
        <span>
          {`Copyright © ${currentYear} Fortinet, Inc. All rights reserved.`}
        </span>
      </Stack>
    </Stack>
  );
};
